import { useEffect } from "react";
import queryString from "query-string";

import ClientStats from "shared/util/ClientStats";
import getMobileType from "shared/util/getMobileType";
import getBrowserInfo from "shared/util/getBrowserInfo";
import {
	isMobile,
	isAndroid,
	isIOS,
} from "shared/util/EnvironmentHelpers";
import isApp from "shared/util/isApp";

function useStats({
	isLoggedIn,
	isStaff,
	location,
}) {
	const platform = isMobile ? "mobile" : "desktop";
	const siteType = isMobile ? "mobile site" : "full site";
	const mobiletype = getMobileType();

	// Page view stats
	useEffect(() => {
		if (isApp()) {
			return;
		}

		ClientStats.update(`okcupid ${siteType}`);

		if (isMobile) {
			ClientStats.update(`page views - mobiletype::${mobiletype} - app capable::${isAndroid || isIOS ? "yes" : "no"}`);
		} else {
			const {
				system,
				browser,
				webkitBrowserType,
			} = getBrowserInfo();
			const loggedInStatus = isLoggedIn ? "logged in" : "logged out";

			ClientStats.update(`browsers - ${loggedInStatus} - platform_os_browser - ${platform} - ${system} - ${webkitBrowserType || browser}`);
			ClientStats.update(`browsers - ${loggedInStatus} - platform_os - ${platform} - ${system}`);
			ClientStats.update(`browsers - ${loggedInStatus} - platform_browser - ${platform} - ${webkitBrowserType || browser}`);
		}
	}, [isLoggedIn, location.pathname, mobiletype, platform, siteType]);

	useEffect(() => {
		if (isApp()) {
			return;
		}

		// Staff page load stats.
		// ---------------------------------------------------------------------
		if (!isStaff) {
			return;
		}

		if (isLoggedIn) {
			ClientStats.update("page loads - is staff - logged in");
		} else {
			ClientStats.update("page loads - is staff - logged out");
		}
	}, [location.pathname, isLoggedIn, isStaff]);

	const {
		cf,
		gmailaction,
		reenabled,
	} = queryString.parse(location.search);

	// Query param stats.
	useEffect(() => {
		if (isApp()) {
			return;
		}

		// Track came from stats
		// -------------------------------------------------------------------------
		if (cf === "home_orbits") {
			ClientStats.update(`home - ${siteType} - orbits profile clicks`);
		} else if (cf === "disabled_mailer") {
			// Came from disabled user mailer and restored account
			if (isLoggedIn) {
				ClientStats.update("account - reenable - from mailer - success");
				ClientStats.update(`account - reenable - from mailer - success - ${platform}`);
			}
		} else if (cf === "inactive_mailer" || cf === "inactive_mailer_match") {
			// Came from disabled user mailer and was inactive
			if (isLoggedIn) {
				ClientStats.update("account - inactive reenable - from mailer");
				ClientStats.update(`account - inactive reenable - from mailer - ${platform}`);

				if (cf === "inactive_mailer_match") {
					ClientStats.update("account - inactive reenable - from mailer match");
					ClientStats.update(`account - inactive reenable - from mailer match - ${platform}`);
				}
			}
		}
	}, [cf, isLoggedIn, platform, siteType]);

	useEffect(() => {
		if (isApp()) {
			return;
		}

		if (reenabled) {
			ClientStats.addUnique(`${siteType} - Account reenabled`);
		}
	}, [reenabled, siteType]);

	useEffect(() => {
		if (isApp()) {
			return;
		}

		if (gmailaction === 1) {
			ClientStats.addUnique("gmail action link clicked");

			if (isLoggedIn) {
				ClientStats.addUnique("gmail action link clicked - logged in");
			} else {
				ClientStats.addUnique("gmail action link clicked - logged out");
			}

			const [, pageName] = location.pathname.split("/");

			if (pageName) {
				ClientStats.addUnique("gmail action link clicked - page - %{pageName}");
			}
		}
	}, [gmailaction, isLoggedIn, location.pathname]);
}

export default useStats;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useStats.js